var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticClass:"d-block text-h6"},[_vm._v("Diese Seite ist nicht mehr gültig")]),_c('v-btn',{attrs:{"text":"","color":"secondary"},on:{"click":_vm.zurueckZurStartseite}},[_vm._v("Zurück zur Startseite")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }